import { useState } from 'react'
import { FormHeader, FormTabs } from './style'
import FormStep4 from './FormStep4'
import useFormState from './state'
import FormStep2 from '../../components/FormStep2'
import FormStep3 from '../../components/FormStep3'
import FormStep1 from '../../components/FormStep1'

const CadastrarEntidade = () => {
    const {
        formState, dispatch, tipoEntidades
    } = useFormState()
    const [tab, setTab] = useState(1)

    const set = (type: string, payload: any) => {
        dispatch({ type, payload })
    }

    const showTab = () => {
        switch (tab) {
        case 2:
            return (
                <FormStep2
                    setTab={setTab}
                    formState={formState}
                    set={set}
                    tipoEntidades={tipoEntidades}
                />
            )
        case 3:
            return (
                <FormStep3
                    setTab={setTab}
                    formState={formState}
                    set={set}
                />
            )
        case 4:
            return (
                <FormStep4
                    setTab={setTab}
                    formState={formState}
                    set={set}
                />
            )
        default:
            return (
                <FormStep1
                    setTab={setTab}
                    formState={formState}
                    set={set}
                />
            )
        }
    }

    return (
        <FormTabs>
            <FormHeader>
                <h1>Cadastro de Entidade</h1>
                <div className="tabBar">
                    <div className={`${tab === 1 ? 'current' : ''}`}>
                        <i className="fas fa-info-circle mr-1" />
                        Informações básicas
                    </div>
                    <div className={`${tab === 2 ? 'current' : ''}`}>
                        <i className="fas fa-info-square mr-1" />
                        Informações adicionais
                    </div>
                    <div className={`${tab === 3 ? 'current' : ''}`}>
                        <i className="fas fa-location mr-1" />
                        Localização
                    </div>
                    <div className={`${tab === 4 ? 'current' : ''}`}>
                        <i className="fas fa-image mr-1" />
                        Imagem
                    </div>
                </div>
            </FormHeader>
            {showTab()}
        </FormTabs>
    )
}

export default CadastrarEntidade
